import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Package, AlertTriangle, Flame, EyeOff, PackageX } from 'lucide-react';

const Card = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-5 flex items-center gap-4" data-testid={`stat-${label}`}>
    <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${color}`}>
      <Icon className="h-6 w-6" strokeWidth={1.6} />
    </div>
    <div>
      <p className="text-xs uppercase tracking-wide text-slate-500 font-semibold">{label}</p>
      <p className="font-display text-3xl text-slate-900">{value}</p>
    </div>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard').then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl text-slate-900 mb-1">Dashboard</h1>
      <p className="text-slate-500 mb-8">Resumen del catálogo en tiempo real</p>

      {stats ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <Card icon={Package} label="Total productos" value={stats.total_products} color="bg-pinky-50 text-pinky-600" />
          <Card icon={AlertTriangle} label="Bajo stock" value={stats.low_stock} color="bg-amber-50 text-amber-600" />
          <Card icon={PackageX} label="Agotados" value={stats.out_of_stock} color="bg-rose-50 text-rose-600" />
          <Card icon={Flame} label="En oferta" value={stats.on_offer} color="bg-purple-50 text-purple-600" />
          <Card icon={EyeOff} label="Ocultos" value={stats.hidden} color="bg-slate-100 text-slate-600" />
        </div>
      ) : (
        <p className="text-slate-500">Cargando…</p>
      )}

      <div className="mt-10 bg-white border border-slate-200 rounded-2xl p-6">
        <h2 className="font-display text-xl text-slate-900 mb-2">Acciones rápidas</h2>
        <p className="text-sm text-slate-500 mb-4">Gestiona tu catálogo desde el menú lateral.</p>
        <div className="flex flex-wrap gap-2">
          <a href="/admin/products" className="px-4 py-2 rounded-full bg-pinky-500 text-white text-sm font-semibold hover:bg-pinky-600">+ Nuevo producto</a>
          <a href="/admin/settings" className="px-4 py-2 rounded-full bg-white border border-pinky-200 text-pinky-600 text-sm font-semibold hover:bg-pinky-50">Cambiar slogan / WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
